import LegalPage from "@/components/feature/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="Privacy Policy"
      subtitle="How Ortho Spine Care handles the information you share with us."
      crumbs={[{ label: "Home", to: "/" }, { label: "Privacy Policy" }]}
      sections={[
        {
          heading: "Information we collect",
          paragraphs: [
            "We collect the information you choose to provide when you request an appointment, contact the clinic, or subscribe to health updates. This may include your name, phone number, email address and details about your reason for contacting us.",
          ],
        },
        {
          heading: "How we use your information",
          paragraphs: [
            "Your information is used only to respond to your enquiry, arrange your appointment and provide care-related communication. We do not sell or rent your personal information.",
          ],
          list: [
            "To contact you and confirm appointment details",
            "To respond to questions you send to the clinic",
            "To send health updates if you have opted in",
          ],
        },
        {
          heading: "Data security",
          paragraphs: [
            "We take reasonable measures to protect the information you share. Please avoid sending highly sensitive medical details through website forms, and share clinical information directly during your consultation.",
          ],
        },
        {
          heading: "Your choices",
          paragraphs: [
            "You may ask us to update or remove your contact details at any time, and you can unsubscribe from health updates whenever you wish by contacting the clinic.",
          ],
        },
      ]}
    />
  );
}